// CustomTooltip.js
import React from 'react';
import { simpleDateFormat } from '../DeviceDetails/helper'; // Import from helper
import { ShortUnits } from '../DeviceDetails/constants'; // Import ShortUnits from constants

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !label) return null;

    const visible = (payload || []).filter((entry) => entry.dataKey !== '__tooltipAnchor');
    const hasValues = visible.some((entry) => entry.value !== undefined && entry.value !== null);

    return (
        <div className="bg-background border border-border rounded p-2 shadow-md max-w-[300px]">
            <p className="text-sm text-foreground mb-1" style={{ fontSize: 14 }}>
                {simpleDateFormat(label)}
            </p>

            {hasValues ? (
                visible.map((entry) => (
                    <div key={entry.dataKey} className="flex items-center gap-1 mb-0.5">
                        <span className="w-2 h-2 rounded-full inline-block" style={{ backgroundColor: entry.color }} />
                        <p className="text-muted-foreground" style={{ fontSize: 12 }}>
                            {entry.name}: {entry.value} {ShortUnits[entry.dataKey] || ''}
                        </p>
                    </div>
                ))
            ) : (
                <p className="text-muted-foreground italic" style={{ fontSize: 12 }}>
                    No data
                </p>
            )}
        </div>
    );
};

export default CustomTooltip;
